import { render, staticRenderFns } from "./MainCarrusel.vue?vue&type=template&id=253cbd6e"
import script from "./MainCarrusel.vue?vue&type=script&lang=js"
export * from "./MainCarrusel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports